import React, { useState, useEffect } from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";

export const Multiselect = ({
	onChange,
	options,
	value,
	classes,
	disabled,
	placeholder,
	loading,
	textField,
	dataItemKey,
	allowCustom,
}) => {
	const c = classes || "kendo-multiselect";

	const [data, setData] = useState([]);

	useEffect(() => {
		setData(options);
	}, [options]);

	const filterChange = (event) => {
		setData(filterBy(options.slice(), event.filter));
	};

	return (
		<MultiSelect
			className={`${c}`}
			fillMode={"solid"}
			rounded={"small"}
			data={data}
			value={value}
			onChange={onChange}
			disabled={disabled}
			loading={loading}
			placeholder={placeholder || "Select..."}
			textField={textField || "display"}
			dataItemKey={dataItemKey || "value"}
			allowCustom={allowCustom}
			filterable={true}
			onFilterChange={filterChange}
		/>
	);
};
